import styled from '@emotion/styled';
import { colors } from '@/constants/colors';

const RequiredAsteriskSpan = styled.span`
  color: ${colors.red};
`;

const RequiredAsterisk = () => <RequiredAsteriskSpan>*</RequiredAsteriskSpan>;

export default RequiredAsterisk;
